
export class Member {
  membersData = {
      id: '',
      first_name: '',
      last_name: '',
      phone: '',
      email: '',
      company_name: ''
  };
  clear() {
      this.membersData.id = '';
      this.membersData.first_name = '';
      this.membersData.last_name = '';
      this.membersData.phone = '';
      this.membersData.email = '';
      this.membersData.company_name = '';
  }

}

// export class Member {
//   id: '';
//   // tslint:disable-next-line:variable-name
//   first_name: '';
//   // tslint:disable-next-line:variable-name
//   last_name: '';
//   phone: '';
//   email: '';
//   // tslint:disable-next-line:variable-name
//   company_name: '';
// }

